// import React, { useState, useEffect, useRef } from "react";
// import "../Styles/FlightRoutes.css";
// import { IoIosArrowDropright, IoIosArrowDropleft } from "react-icons/io";

// const FlightRoutes = ({ onSelectRoute }) => {
//   const [routes, setRoutes] = useState([]);
//   const [departureOptions, setDepartureOptions] = useState([]);
//   const [selectedCity, setSelectedCity] = useState("");
//   const blueRoutesRef = useRef(null);
//   const redRoutesRef = useRef(null);

//   const storedToken = localStorage.getItem("b2bAuthToken");
//   const parsedToken = storedToken ? JSON.parse(storedToken) : null;
//   const externalApiToken = parsedToken ? parsedToken.externalApiToken : null;

//   useEffect(() => {
//     if (!externalApiToken) {
//       console.error("Authorization token is missing.");
//       return;
//     }

//     fetch("https://b2bdubaibackendapi.mmstourism.com/api/b2/user/sectors", {
//       headers: {
//         Authorization: `${externalApiToken}`,
//       },
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success" && data.data) {
//           const uniqueOrigins = Array.from(
//             new Set(data.data.map((item) => item.Origin))
//           ).map((origin) => {
//             const matchedItem = data.data.find((item) => item.Origin === origin);
//             return {
//               code: origin,
//               name: matchedItem ? matchedItem.Sector.split(" // ")[0] : origin,
//             };
//           });
//           setDepartureOptions(uniqueOrigins);
//           setRoutes(data.data);


//         // Check if "Mumbai" exists, otherwise set the first option
//         const mumbaiOption = uniqueOrigins.find(
//           (option) => option.name.toLowerCase() === "mumbai"
//         );
//         if (mumbaiOption) {
//           setSelectedCity(mumbaiOption.name);
//         } else if (uniqueOrigins.length > 0) {
//           setSelectedCity(uniqueOrigins[0].name);
//         }
//       }
//     })
//       .catch((error) => console.error("Error fetching sectors:", error));
//   }, [externalApiToken]);

//   const selectedCityCode = departureOptions.find(
//     (option) => option.name === selectedCity
//   )?.code;

//   const blueRoutes = routes.filter(
//     (route) => route.Origin === selectedCityCode
//   );
//   const redRoutes = routes.filter(
//     (route) => route.Destination === selectedCityCode
//   );

//   const handleScroll = (direction, ref) => {
//     if (ref && ref.current) {
//       const scrollAmount = direction === "left" ? -250 : 250; // Amount to scroll
//       ref.current.scrollBy({
//         left: scrollAmount,
//         behavior: "smooth",
//       });
//     }
//   };
//   return (
//     <div className="flight-routes-container">
//       <div className="dropdown">
//         <select
//           value={selectedCity}
//           onChange={(e) => setSelectedCity(e.target.value)}
//         >
//           {departureOptions.map((option, index) => (
//             <option key={index} value={option.name}>
//               {option.name}
//             </option>
//           ))}
//         </select>
//         <div className="navigation">
//         <button
//           className="nav-button"
//           onClick={() => {
//             handleScroll("left", blueRoutesRef);
//             handleScroll("left", redRoutesRef);
//           }}
//         >
//           <IoIosArrowDropleft size={25} color='000000'/>
//         </button>
//         <button
//           className="nav-button"
//           onClick={() => {
//             handleScroll("right", blueRoutesRef);
//             handleScroll("right", redRoutesRef);
//           }}
//         >
//         <IoIosArrowDropright size={25} color='000000'/>
//         </button>
//       </div>
//       </div>

//       <div className="routes-container">
//         {/* Blue Buttons */}
//         <div className="routes-row blue-buttons-row" ref={blueRoutesRef}>
//           {blueRoutes.map((route, index) => (
//             <button
//               key={index}
//               className="route-button blue"
//               onClick={() => onSelectRoute(route.Origin, route.Destination)}
//             >
//               {`${route.Origin} ✈ ${route.Destination}`}
//             </button>
//           ))}
//         </div>

//         {/* Red Buttons */}
//         <div className="routes-row red-buttons-row" ref={redRoutesRef}>
//           {redRoutes.map((route, index) => (
//             <button
//               key={index}
//               className="route-button red"
//               onClick={() => onSelectRoute(route.Origin, route.Destination)}
//             >
//               {`${route.Origin} ✈ ${route.Destination}`}
//             </button>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FlightRoutes;
import React, { useState, useEffect, useRef } from "react";
import "../Styles/FlightRoutes.css";
import { IoIosArrowDropright, IoIosArrowDropleft } from "react-icons/io";

const FlightRoutes = ({ onSelectRoute }) => {
  const [routes, setRoutes] = useState([]);
  const [departureOptions, setDepartureOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const blueRoutesRef = useRef(null);
  const redRoutesRef = useRef(null);

  const storedToken = localStorage.getItem("b2bAuthToken");
  const parsedToken = storedToken ? JSON.parse(storedToken) : null;
  const externalApiToken = parsedToken ? parsedToken.externalApiToken : null;

  useEffect(() => {
    if (!externalApiToken) {
      console.error("Authorization token is missing.");
      return;
    }

    fetch("https://b2bdubaibackendapi.mmstourism.com/api/b2/user/sectors", {
      headers: {
        Authorization: `Bearer ${externalApiToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.data) {
          const uniqueOrigins = Array.from(
            new Set(data.data.map((item) => item.origin))
          ).map((originCode) => {
            const matchedItem = data.data.find((item) => item.origin === originCode);
            return {
              code: originCode,
              name: matchedItem
                ? matchedItem.sectorName.split(" // ")[0]
                : originCode,
            };
          });

          setDepartureOptions(uniqueOrigins);
          setRoutes(data.data);

          // Default to Mumbai if available
          const mumbaiOption = uniqueOrigins.find(
            (option) => option.name.toLowerCase() === "mumbai"
          );
          if (mumbaiOption) {
            setSelectedCity(mumbaiOption.name);
          } else if (uniqueOrigins.length > 0) {
            setSelectedCity(uniqueOrigins[0].name);
          }
        }
      })
      .catch((error) => console.error("Error fetching sectors:", error));
  }, [externalApiToken]);

  const selectedCityCode = departureOptions.find(
    (option) => option.name === selectedCity
  )?.code;

  const blueRoutes = routes.filter(
    (route) => route.origin === selectedCityCode
  );
  const redRoutes = routes.filter(
    (route) => route.destination === selectedCityCode
  );

  const handleScroll = (direction, ref) => {
    if (ref && ref.current) {
      const scrollAmount = direction === "left" ? -250 : 250;
      ref.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="flight-routes-container">
      <div className="dropdown">
        <select
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
        >
          {departureOptions.map((option, index) => (
            <option key={index} value={option.name}>
              {option.name}
            </option>
          ))}
        </select>
        <div className="navigation">
          <button
            className="nav-button"
            onClick={() => {
              handleScroll("left", blueRoutesRef);
              handleScroll("left", redRoutesRef);
            }}
          >
            <IoIosArrowDropleft size={25} color="000000" />
          </button>
          <button
            className="nav-button"
            onClick={() => {
              handleScroll("right", blueRoutesRef);
              handleScroll("right", redRoutesRef);
            }}
          >
            <IoIosArrowDropright size={25} color="000000" />
          </button>
        </div>
      </div>

      <div className="routes-container">
        {/* Blue Buttons */}
        <div className="routes-row blue-buttons-row" ref={blueRoutesRef}>
          {blueRoutes.map((route, index) => (
            <button
              key={index}
              className="route-button blue"
              onClick={() => onSelectRoute(route.origin, route.destination)}
            >
              {`${route.origin} ✈ ${route.destination}`}
            </button>
          ))}
        </div>

        {/* Red Buttons */}
        <div className="routes-row red-buttons-row" ref={redRoutesRef}>
          {redRoutes.map((route, index) => (
            <button
              key={index}
              className="route-button red"
              onClick={() => onSelectRoute(route.origin, route.destination)}
            >
              {`${route.origin} ✈ ${route.destination}`}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FlightRoutes;
